import React from 'react'
import axios from 'axios'
import PropTypes from 'prop-types'

import Loader from 'Pods/Shared/Loader'
import ProductAnalyticsTopKeywordsDashboard from 'Pods/Profile/ProductAnalytics/Components/ProductAnalyticsTopKeywordsDashboard'

class AnalyticsTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      keywords: {
        top: {
          data: {},
          meta: {
            searchParams: {
              page: 1,
              per_page: this.props.tiersData.data.user.currentTier === 1 ? 10 : 5,
              sort_by: ['recommendation', 'desc'],
              keywords_count: 1,
              group: 'categories',
            },
          },
          hidden: true,
        },
      },
      isDataFetched: false,
      axiosSource: axios.CancelToken.source(),
    }

    this.fetchData = this.fetchData.bind(this)
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData() {
    return axios.get('/api/internal/keyword-analytics', {
      params: this.state.keywords.top.meta.searchParams,
      cancelToken: this.state.axiosSource.token,
    })
      .then((response) => this.onFetchSuccess(response))
      .catch((error) => {})
  }

  onFetchSuccess(response) {
    return this.setState(prevState => ({
      keywords: {
        ...prevState.keywords,
        top: {
          ...prevState.keywords.top,
          data: response.data.data.slice(0, 5),
          meta: response.data.meta,
        },
      },
      isDataFetched: true,
    }))
  }

  render() {
    return (
      <div className="dashboard-analytics">
        {!this.state.isDataFetched ? (
          <Loader />
        ) : (
          this.state.keywords.top.data.length === 0 ? (
            <div className="empty-content u-text-center">
              <p>
                Ooops! Something went wrong
              </p>
            </div>
          ) : (
            <div className="site-page--product-analytics">
              <ProductAnalyticsTopKeywordsDashboard
                keywords={this.state.keywords.top}
                tiersData={this.props.tiersData}
              />
            </div>
          ))}
      </div>
    )
  }
}

AnalyticsTable.propTypes = {
  tiersData: PropTypes.object.isRequired,
}

export default AnalyticsTable
